import React from 'react';
import { useScope } from '../scopeContext';

const ScopeSelector: React.FC = () => {
  const { scope } = useScope();

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 11, textTransform: 'uppercase', color: '#888' }}>Project</div>
      <span style={{
        display: 'inline-block',
        marginTop: 4,
        padding: '2px 8px',
        borderRadius: 12,
        background: '#e3f2fd',
        color: '#1565c0',
        fontSize: 12,
        fontWeight: 500,
      }}>
        {scope.project_id ?? 'All projects'}
      </span>
    </div>
  );
};

export default ScopeSelector;
